import { makeImage } from "../utils";
import acceptApprove from "./accept-approve.svg";

export const AcceptApprove = makeImage({
  src: acceptApprove,
  width: 133,
  height: 128,
  dataTestId: "accept-approve",
});
